import { initializeEventasticCalendarBlock } from "./calendar";
jQuery("document").ready(function($) {
    initializeEventasticCalendarBlock();        
});